<template>
  {{ formattedNumber }}
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  notation?: 'standard' | 'scientific' | 'engineering' | 'compact';
  numberToFormat: number;
  withPenceValue?: boolean;
}>();

const formattedNumber = computed(() => new Intl.NumberFormat('en-GB', {
  notation: props.notation ?? 'standard',
  style: 'currency',
  currency: 'GBP',
  minimumFractionDigits: props.withPenceValue && (props.numberToFormat % 1) ? 2 : 0,
  maximumFractionDigits: props.withPenceValue ? 2 : 0,
}).format(props.numberToFormat));
</script>
